
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35129',
  depVersions: {
  "documents-public-ui": "static-1.35129",
  "atom": "static-1.5338",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2749",
  "client-types": "static-1.492",
  "cssUtils": "static-1.872",
  "customer-data-filters-ui": "static-1.40777",
  "customer-data-objects": "static-1.7938",
  "customer-data-property-utils": "static-1.8350",
  "documents-lib": "static-1.35134",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.360",
  "FormsCommonComponents": "static-1.86478",
  "FormUrlGenerator": "static-2.4978",
  "foundations-theming-specialty": "static-1.2428",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5849",
  "hs-test-utils": "static-1.8278",
  "hub-http": "static-1.6465",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12042",
  "HubStyleTokens": "static-2.11735",
  "I18n": "static-7.1663",
  "icons": "static-2.674",
  "jasmine-immutable": "static-1.3274",
  "jasmine-runner": "static-1.6700",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7404",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3149",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5648",
  "quartz": "static-1.7377",
  "react": "static-7.191",
  "react-dlb": "static-1.85",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.9",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5520",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8433",
  "reference-resolvers-lite": "static-1.8352",
  "reporting-data": "static-1.68615",
  "reporting-reports": "static-1.68293",
  "reporting-snowflake": "static-1.57233",
  "reporting-testing-lib": "static-1.10548",
  "reporting-visualizations": "static-1.60691",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9202",
  "sanitize": "static-1.4728",
  "sanitize-text": "static-1.8402",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1999",
  "signup-constants": "static-1.19513",
  "signup-ui-url-generator": "static-2.8312",
  "StyleGuideUI": "static-3.495",
  "superstore": "static-1.5009",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5007",
  "ui-addon-form-validation": "static-1.11238",
  "ui-asset-management-lib": "static-1.11348",
  "ui-images": "static-2.1230",
  "UIComponents": "static-3.8681",
  "usage-tracker": "static-1.7608",
  "usage-tracker-container": "static-1.7598",
  "usage-tracker-core": "static-1.7458",
  "viral-links-lib": "static-1.7326",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9908",
  "foundations-components": "static-1.8396",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1155",
  "quartz-core": "static-1.6596",
  "quick-fetch": "static-1.4098",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4915",
  "ui-addon-i18n": "static-1.11396",
  "ui-addon-upgrades": "static-9.18324",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3582",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3654",
  "quartz-webpack": "static-1.3601",
  "foundations-assets": "static-1.5131",
  "foundations-theming": "static-1.4712",
  "hub-http-shared-msw-handlers": "static-1.10534",
  "hubspotter-http": "static-1.4829",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7500",
  "crm-message-bus": "static-1.43652",
  "customer-data-filters-ui-msw-helpers": "static-1.23212",
  "customer-data-objects-ui-components": "static-1.13281",
  "customer-data-reference-ui-components": "static-1.13432",
  "customer-data-ui-utilities": "static-1.10079",
  "events-data-lib": "static-1.494",
  "framework-builder-read-service-client": "static-1.4186",
  "hs-resources": "static-1.443",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4023",
  "multi-account-reference-resolvers": "static-1.1247",
  "onboarding-scopes": "static-1.6707",
  "onboarding-tours": "static-1.17046",
  "pulse": "static-1.878",
  "reporting-datasets-permissions-lib": "static-1.14377",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2492",
  "trellis-components": "static-1.2511",
  "trellis-theming": "static-1.1217",
  "ui-addon-teams": "static-1.21858",
  "quartz-auth": "static-1.1052",
  "ui-business-units-lib": "static-1.9335",
  "usage-tracker-session-replay": "static-1.5294",
  "ai-components-ui-library": "static-1.9603",
  "ContentUtils": "static-1.69063",
  "customer-data-properties": "static-1.52448",
  "forms-ai-lib": "static-1.4695",
  "forms-utils-lib": "static-1.13026",
  "foundations-components-test-utils": "static-1.5879",
  "react-dnd-compat": "static-1.4867",
  "react-tinymce": "static-1.55886",
  "tinymce-config": "static-2.55012",
  "ui-gdpr-components": "static-1.10607",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3697",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3389",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.259",
  "ui-fonts": "static-1.997",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4569",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1042",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1794",
  "external-options-client-types": "static-1.4305",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7144",
  "quartz-i18n": "static-1.1052",
  "frontend-preferences-client": "static-1.8180",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3951",
  "reporting-client-types": "static-1.2652",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26083",
  "hubspot-apollo-client": "static-1.5131",
  "foundations-components-legacy": "static-1.1421",
  "quartz-routing": "static-1.807",
  "hs-story-utils": "static-1.9679",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.486",
  "seat-types-lib": "static-1.634",
  "timezone-utils": "static-2.5499",
  "react-create-root-preference": "static-1.63",
  "bend-plugin-foundations-components": "static-1.4665",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.18",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.393",
  "quartz-test": "static-1.1052",
  "quartz-tracking": "static-1.756",
  "bend-plugin-chirp-manifest": "static-1.325",
  "chirp-fetch": "static-1.2144",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6289",
  "salesImages": "static-1.530",
  "ts-schema": "static-1.4259",
  "bender-build-tools": "static-1.3382",
  "bend-plugin-foundations-theming": "static-1.3195",
  "restore-request-side-panel-lib": "static-1.1564",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4910",
  "conditional-properties-service-client": "static-1.3980",
  "crm-pipelines-api-client-types": "static-1.4314",
  "event-emitter": "static-1.1206",
  "fdsr-migration-layer": "static-1.263",
  "multi-currency-client-types": "static-1.3874",
  "getting-started-shared-tasks": "static-1.19124",
  "growth-data-modal": "static-1.5825",
  "growth-onboarding-confetti": "static-1.3313",
  "growth-onboarding-next-action-utils": "static-1.2603",
  "navigation-components": "static-1.18721",
  "onboarding-tours-client": "static-1.5260",
  "onboarding-tours-utils": "static-1.1112",
  "ui-shepherd-react": "static-3.10516",
  "ui-shepherd-tracker": "static-1.7897",
  "ui-universal-auth": "static-1.9300",
  "user-context": "static-1.5366",
  "bend-plugin-pulse": "static-1.381",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10532",
  "magpie-lib": "static-1.5722",
  "navigation-messaging": "static-1.8048",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22675",
  "copilot-toolkit": "static-1.11755",
  "cms-field-types": "static-1.5067",
  "content-icons-ui": "static-1.2316",
  "integrations-lib": "static-1.16936",
  "calling-global-api": "static-1.65388",
  "calling-internal-common": "static-1.31569",
  "calling-lifecycle-internal": "static-1.66770",
  "calling-lifecycle-messages": "static-1.59064",
  "commerce-products-lib": "static-1.10419",
  "crm-index-visualization-core": "static-1.4482",
  "crm-links": "static-1.6576",
  "customer-data-properties-shared-msw-handlers": "static-1.9861",
  "file-manager-components": "static-1.24370",
  "formula-editor": "static-1.14683",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4391",
  "meetings-icalendar-utils-lib": "static-1.888",
  "object-builder-ui-client": "static-1.49547",
  "pipeline-validation-client-types": "static-1.4148",
  "property-value-citations": "static-1.3062",
  "smart-data-capture-core": "static-1.36",
  "smart-property-lib": "static-1.8179",
  "tiered-pricing": "static-1.1874",
  "trial-components-library": "static-1.14031",
  "topics-actions-lib": "static-1.416",
  "ui-addon-iframeable": "static-1.9327",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20241",
  "tinymce-themes": "static-1.56982",
  "data-token-picker": "static-1.16820",
  "hub-http-contrib": "static-1.3291",
  "interframe": "static-3.5008",
  "tinymce-data": "static-1.41097",
  "tinymce-plugins": "static-1.58126",
  "ui-addon-sales-email": "static-1.5466",
  "framework-data-schema-quick-fetch": "static-1.7049",
  "ui-addon-opt": "static-4.8617",
  "hubspot-apollo-cache": "static-1.590",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6292",
  "onboarding-data-sync-lib": "static-1.2420",
  "growth-onboarding-next-action-components": "static-1.2631",
  "user-context-client": "static-1.4760",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5182",
  "nest": "static-1.487",
  "reactive-lib": "static-1.973",
  "simple-logging-lib": "static-1.3303",
  "unified-auth-core-lib": "static-1.1096",
  "getting-started-shared-tasks-store": "static-1.18242",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1583",
  "integrations-error-boundary-lib": "static-1.14351",
  "integrations-tracking-lib": "static-1.5860",
  "native-integrations-shared-strings": "static-1.8029",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10618",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.814",
  "calling-error-reporting": "static-1.31576",
  "shared-worker-versioning": "static-1.11293",
  "calling-usage-tracker": "static-1.6791",
  "voice-sms-access-library": "static-1.1921",
  "customer-data-tracking": "static-1.7133",
  "commerce-permissions": "static-1.1028",
  "products-iframe-lib": "static-1.8505",
  "products-ui-components-shared-msw-handlers": "static-1.10916",
  "crm-index-associations-lib": "static-1.6696",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10617",
  "sales-views-client-types": "static-1.4509",
  "location-customization-utils-lib": "static-1.9998",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4403",
  "video-components-external": "static-1.12072",
  "video-data-lib": "static-1.35730",
  "bark-lib": "static-1.16758",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6142",
  "react-codemirror": "static-1.10891",
  "data-agent-kit": "static-1.580",
  "feedback-loader": "static-1.29740",
  "fsm": "static-1.3992",
  "policy-lib": "static-1.7047",
  "react-colorpicker": "static-2.10460",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10680",
  "embedded-academy-lib": "static-1.15382",
  "hubs-service-types": "static-1.1510",
  "FileManagerLib": "static-1.40010",
  "NamespacedHubStyle": "static-2.9228",
  "FileManagerCore": "static-1.39869",
  "content-assistance-lib": "static-1.8139",
  "layout-dnd-components": "static-1.12898",
  "layout-dnd-utils": "static-1.11873",
  "ui-addon-emoji-picker": "static-1.10136",
  "ui-brand-identity-lib": "static-1.16237",
  "InboxConnectUtils": "static-4.15467",
  "meetings-connect-utils-lib": "static-1.7861",
  "breeze-engine-chat-components": "static-1.561",
  "breeze-engine-core": "static-1.861",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3261",
  "adobe-sign-auth-lib": "static-1.362",
  "ads-unified-auth-lib": "static-1.1089",
  "google-sheets-integration-lib": "static-1.939",
  "microsoft-drive-auth-lib": "static-1.32",
  "surveymonkey-integration-lib": "static-1.383",
  "slack-ui-library": "static-1.10650",
  "calling-orchestration-schema": "static-1.36698",
  "crm-record-cards-service-types": "static-1.3759",
  "content-media-composition-data-lib": "static-1.13128",
  "content-media-compositions": "static-2.17135",
  "media-bridge-lib": "static-1.19343",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16276",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4763",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14842",
  "audio-components": "static-1.6279",
  "FileManagerImages": "static-1.37521",
  "video-components": "static-1.14074",
  "breeze-artifacts-sdk": "static-1.201",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4784",
  "video-embed": "static-1.36564",
  "ui-addon-video-player": "static-1.8955",
  "ui-coaching-tips": "static-1.29223",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10198",
  "academy-service-client": "static-1.3941",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4657",
  "trellis-ecosystem": "static-1.7566",
  "ui-addon-react-router-dom": "static-1.9789",
  "wootric-nps": "static-1.7165",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4412",
  "growth-onboarding-feedback-components": "static-1.6836",
  "advanced-menus-core": "static-1.15516",
  "advanced-menus-lib": "static-1.12396",
  "ExportDialog": "static-6.10631",
  "ui-memberships-settings-lib": "static-1.34746",
  "marketplace-ui-apps-core": "static-1.19146",
  "marketplace-ui-common": "static-1.20614",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15515",
  "simple-menus-lib": "static-1.17032",
  "developer-experience-shared-components": "static-1.10753",
  "immutable-less": "static-1.4903",
  "marketplace-ui-client-types": "static-1.18021",
  "ui-addon-integrations-directory-panel": "static-2.8278",
  "ui-extensibility-client-types": "static-1.4173",
  "ai-settings-ui-library": "static-1.8263",
  "nav-meta": "static-1.30358",
  "ui-product-approvals-common": "static-1.890",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3444"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35129",
  "atom": "/atom/static-1.5338",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2749",
  "client-types": "/client-types/static-1.492",
  "cssUtils": "/cssUtils/static-1.872",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40777",
  "customer-data-objects": "/customer-data-objects/static-1.7938",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8350",
  "documents-lib": "/documents-lib/static-1.35134",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.360",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4978",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2428",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5849",
  "hs-test-utils": "/hs-test-utils/static-1.8278",
  "hub-http": "/hub-http/static-1.6465",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12042",
  "HubStyleTokens": "/HubStyleTokens/static-2.11735",
  "I18n": "/I18n/static-7.1663",
  "icons": "/icons/static-2.674",
  "jasmine-immutable": "/jasmine-immutable/static-1.3274",
  "jasmine-runner": "/jasmine-runner/static-1.6700",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7404",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3149",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5648",
  "quartz": "/quartz/static-1.7377",
  "react": "/react/static-7.191",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.9",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5520",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8433",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8352",
  "reporting-data": "/reporting-data/static-1.68615",
  "reporting-reports": "/reporting-reports/static-1.68293",
  "reporting-snowflake": "/reporting-snowflake/static-1.57233",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10548",
  "reporting-visualizations": "/reporting-visualizations/static-1.60691",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9202",
  "sanitize": "/sanitize/static-1.4728",
  "sanitize-text": "/sanitize-text/static-1.8402",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1999",
  "signup-constants": "/signup-constants/static-1.19513",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8312",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "superstore": "/superstore/static-1.5009",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5007",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11238",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11348",
  "ui-images": "/ui-images/static-2.1230",
  "UIComponents": "/UIComponents/static-3.8681",
  "usage-tracker": "/usage-tracker/static-1.7608",
  "usage-tracker-container": "/usage-tracker-container/static-1.7598",
  "usage-tracker-core": "/usage-tracker-core/static-1.7458",
  "viral-links-lib": "/viral-links-lib/static-1.7326",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9908",
  "foundations-components": "/foundations-components/static-1.8396",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1155",
  "quartz-core": "/quartz-core/static-1.6596",
  "quick-fetch": "/quick-fetch/static-1.4098",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4915",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11396",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18324",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3582",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3654",
  "quartz-webpack": "/quartz-webpack/static-1.3601",
  "foundations-assets": "/foundations-assets/static-1.5131",
  "foundations-theming": "/foundations-theming/static-1.4712",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10534",
  "hubspotter-http": "/hubspotter-http/static-1.4829",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7500",
  "crm-message-bus": "/crm-message-bus/static-1.43652",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23212",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13281",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13432",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10079",
  "events-data-lib": "/events-data-lib/static-1.494",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4186",
  "hs-resources": "/hs-resources/static-1.443",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4023",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1247",
  "onboarding-scopes": "/onboarding-scopes/static-1.6707",
  "onboarding-tours": "/onboarding-tours/static-1.17046",
  "pulse": "/pulse/static-1.878",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14377",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2492",
  "trellis-components": "/trellis-components/static-1.2511",
  "trellis-theming": "/trellis-theming/static-1.1217",
  "ui-addon-teams": "/ui-addon-teams/static-1.21858",
  "quartz-auth": "/quartz-auth/static-1.1052",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9335",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5294",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9603",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-properties": "/customer-data-properties/static-1.52448",
  "forms-ai-lib": "/forms-ai-lib/static-1.4695",
  "forms-utils-lib": "/forms-utils-lib/static-1.13026",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5879",
  "react-dnd-compat": "/react-dnd-compat/static-1.4867",
  "react-tinymce": "/react-tinymce/static-1.55886",
  "tinymce-config": "/tinymce-config/static-2.55012",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10607",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3697",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3389",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.259",
  "ui-fonts": "/ui-fonts/static-1.997",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4569",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1042",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1794",
  "external-options-client-types": "/external-options-client-types/static-1.4305",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7144",
  "quartz-i18n": "/quartz-i18n/static-1.1052",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8180",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3951",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26083",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5131",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1421",
  "quartz-routing": "/quartz-routing/static-1.807",
  "hs-story-utils": "/hs-story-utils/static-1.9679",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.486",
  "seat-types-lib": "/seat-types-lib/static-1.634",
  "timezone-utils": "/timezone-utils/static-2.5499",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4665",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.18",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.393",
  "quartz-test": "/quartz-test/static-1.1052",
  "quartz-tracking": "/quartz-tracking/static-1.756",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.325",
  "chirp-fetch": "/chirp-fetch/static-1.2144",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6289",
  "salesImages": "/salesImages/static-1.530",
  "ts-schema": "/ts-schema/static-1.4259",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3195",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1564",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4910",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3980",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4314",
  "event-emitter": "/event-emitter/static-1.1206",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.263",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3874",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19124",
  "growth-data-modal": "/growth-data-modal/static-1.5825",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3313",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2603",
  "navigation-components": "/navigation-components/static-1.18721",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5260",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1112",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10516",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7897",
  "ui-universal-auth": "/ui-universal-auth/static-1.9300",
  "user-context": "/user-context/static-1.5366",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.381",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10532",
  "magpie-lib": "/magpie-lib/static-1.5722",
  "navigation-messaging": "/navigation-messaging/static-1.8048",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22675",
  "copilot-toolkit": "/copilot-toolkit/static-1.11755",
  "cms-field-types": "/cms-field-types/static-1.5067",
  "content-icons-ui": "/content-icons-ui/static-1.2316",
  "integrations-lib": "/integrations-lib/static-1.16936",
  "calling-global-api": "/calling-global-api/static-1.65388",
  "calling-internal-common": "/calling-internal-common/static-1.31569",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66770",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59064",
  "commerce-products-lib": "/commerce-products-lib/static-1.10419",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4482",
  "crm-links": "/crm-links/static-1.6576",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9861",
  "file-manager-components": "/file-manager-components/static-1.24370",
  "formula-editor": "/formula-editor/static-1.14683",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4391",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.888",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49547",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4148",
  "property-value-citations": "/property-value-citations/static-1.3062",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.36",
  "smart-property-lib": "/smart-property-lib/static-1.8179",
  "tiered-pricing": "/tiered-pricing/static-1.1874",
  "trial-components-library": "/trial-components-library/static-1.14031",
  "topics-actions-lib": "/topics-actions-lib/static-1.416",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9327",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20241",
  "tinymce-themes": "/tinymce-themes/static-1.56982",
  "data-token-picker": "/data-token-picker/static-1.16820",
  "hub-http-contrib": "/hub-http-contrib/static-1.3291",
  "interframe": "/interframe/static-3.5008",
  "tinymce-data": "/tinymce-data/static-1.41097",
  "tinymce-plugins": "/tinymce-plugins/static-1.58126",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5466",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7049",
  "ui-addon-opt": "/ui-addon-opt/static-4.8617",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.590",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6292",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2420",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2631",
  "user-context-client": "/user-context-client/static-1.4760",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5182",
  "nest": "/nest/static-1.487",
  "reactive-lib": "/reactive-lib/static-1.973",
  "simple-logging-lib": "/simple-logging-lib/static-1.3303",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1096",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18242",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1583",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14351",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5860",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8029",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10618",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.814",
  "calling-error-reporting": "/calling-error-reporting/static-1.31576",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11293",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6791",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1921",
  "customer-data-tracking": "/customer-data-tracking/static-1.7133",
  "commerce-permissions": "/commerce-permissions/static-1.1028",
  "products-iframe-lib": "/products-iframe-lib/static-1.8505",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10916",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6696",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10617",
  "sales-views-client-types": "/sales-views-client-types/static-1.4509",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9998",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4403",
  "video-components-external": "/video-components-external/static-1.12072",
  "video-data-lib": "/video-data-lib/static-1.35730",
  "bark-lib": "/bark-lib/static-1.16758",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6142",
  "react-codemirror": "/react-codemirror/static-1.10891",
  "data-agent-kit": "/data-agent-kit/static-1.580",
  "feedback-loader": "/feedback-loader/static-1.29740",
  "fsm": "/fsm/static-1.3992",
  "policy-lib": "/policy-lib/static-1.7047",
  "react-colorpicker": "/react-colorpicker/static-2.10460",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10680",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15382",
  "hubs-service-types": "/hubs-service-types/static-1.1510",
  "FileManagerLib": "/FileManagerLib/static-1.40010",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9228",
  "FileManagerCore": "/FileManagerCore/static-1.39869",
  "content-assistance-lib": "/content-assistance-lib/static-1.8139",
  "layout-dnd-components": "/layout-dnd-components/static-1.12898",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11873",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10136",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16237",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15467",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7861",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.561",
  "breeze-engine-core": "/breeze-engine-core/static-1.861",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3261",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.362",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1089",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.939",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.32",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.383",
  "slack-ui-library": "/slack-ui-library/static-1.10650",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36698",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13128",
  "content-media-compositions": "/content-media-compositions/static-2.17135",
  "media-bridge-lib": "/media-bridge-lib/static-1.19343",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16276",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4763",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14842",
  "audio-components": "/audio-components/static-1.6279",
  "FileManagerImages": "/FileManagerImages/static-1.37521",
  "video-components": "/video-components/static-1.14074",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.201",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4784",
  "video-embed": "/video-embed/static-1.36564",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8955",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29223",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10198",
  "academy-service-client": "/academy-service-client/static-1.3941",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4657",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7566",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9789",
  "wootric-nps": "/wootric-nps/static-1.7165",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4412",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6836",
  "advanced-menus-core": "/advanced-menus-core/static-1.15516",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12396",
  "ExportDialog": "/ExportDialog/static-6.10631",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34746",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19146",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20614",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15515",
  "simple-menus-lib": "/simple-menus-lib/static-1.17032",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10753",
  "immutable-less": "/immutable-less/static-1.4903",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18021",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8278",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4173",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8263",
  "nav-meta": "/nav-meta/static-1.30358",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.890",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3444"
}
};
